import React from "react";

import imgC from "../../assets/image/inner-page/png/trips-detail.png";
import imgP from "../../assets/image/inner-page/png/patterns-dot-green.png";
import imgH from "../../assets/image/inner-page/png/right-circlehalf-shape.png";

const Content2 = ({ className, ...rest }) => {
  const contentWidgetData = [
    {
      icon: "fa-tasks",
      title: "Organización",
      text: "Organiza cualquier viaje de una forma muy cómoda.",
      color: "blue-3",
    },
    {
      icon: "fa-comment",
      title: "Comunicación",
      text: "Comunícate con todas las partes: personas y agencia de viajes.",
      color: "buttercup",
    },
    {
      icon: "fa-receipt",
      title: "Certificación con la Agencia Tributaria",
      text: "Todos los tickets ya estarán certificados.",
      color: "dark-green",
    },
    {
      icon: "fa-file-invoice",
      title: "Liquidación",
      text: "A la hora de liquidar, ya sabes donde tienes todas las facturas.",
      color: "golden-yellow",
    },
    {
      icon: "fa-undo-alt",
      title: "Cancelación",
      text: "Si algo no sale como esperas, lo cancelas y listo.",
      color: "red",
    },
    {
      icon: "fa-piggy-bank",
      title: "Ahorro",
      text: "Elimina procedimientos molestos y mucho papeleo.",
      color: "scooter",
    },
  ];
  return (
    <>
      <div className={className} {...rest}>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            {/* Left */}
            <div
              className="col-xl-5 col-lg-5 col-md-6 col-xs-8 order-2 order-md-1"
              data-aos="fade-right"
              data-aos-delay={500}
              data-aos-once="true"
            >
              <h2 className="font-size-10">Por qué te va a encantar</h2>
              <ul className="list-unstyled mt-9 mt-lg-14">
                {contentWidgetData.map(
                  ({ icon, title, text, color }, index) => {
                    return (
                      <li
                        className="media align-items-center mb-12"
                        key={index}
                      >
                        <div className="border square-83 rounded-10 mr-9">
                          <span className={`text-${color} font-size-9`}>
                            <i className={`fa ${icon}`} />
                          </span>
                        </div>
                        <div className="content">
                          <h5>{title}</h5>
                          <p className="font-size-5 line-height-28 mb-0">
                            {text}
                          </p>
                        </div>
                      </li>
                    );
                  }
                )}
              </ul>
            </div>
            {/* Left End */}
            {/* Right */}
            <div
              className="col-xl-6 offset-xl-1 col-lg-7 col-md-6 col-xs-8 order-1 order-md-2"
              data-aos="fade-left"
              data-aos-delay={500}
              data-aos-once="true"
            >
              <div className="l2-content-image-group-2 mb-10 mb-md-0 rounded-10">
                <div className="img-1 position-relative text-right rounded-10">
                  <img className="w-100 w-lg-auto" src={imgC} alt="" />
                  <div className="img-2">
                    <img className="w-100 opacity-3" src={imgP} alt="" />
                  </div>
                  <div className="img-3">
                    <img className="w-100 opacity-3" src={imgH} alt="" />
                  </div>
                </div>
              </div>
            </div>
            {/* Right */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Content2;
